import axios from "axios"
import { showSuccess, showError, showWarning } from "../utils/helper/toastHelper";
import { navigateTo } from "../utils/helper/navigationHelper";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_WISDOM_API_BASE_URL,
  timeout: 30000,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  function onFulfilled(response) {
    const { config, data } = response;

    if (config.method !== "get" && config.successToast) {
      const message =
        typeof config.successToast === "string"
          ? config.successToast
          : data?.message || "Operation completed successfully";

      showSuccess(message);
    }

    return response;
  },

  async function onRejected(error) {

    if (!error.response) {
      if (error.code === "ECONNABORTED") {
        showError("Request timeout exceeded");
      } else {
        showError("Network error. Please check your connection.");
      }

      return Promise.reject(error);
    }

    const { status } = error.response;

    let data = error.response.data;

    // Requests using responseType: "blob" also return errors as Blob
    if (data instanceof Blob) {
      try {
        const text = await data.text();
        data = JSON.parse(text);
      } catch (parseError) {
        console.error("Error parsing Blob error response:", parseError);
      }
    }

    const message =
      data?.message ||
      data?.error ||
      "An unexpected error occurred";

    switch (status) {
      case 400:
        showWarning(message);
        break;

      case 401: {
        const token = sessionStorage.getItem("token");

        if (token) {
          sessionStorage.clear();
          navigateTo("/signIn");
          showError("Session expired. Please login again.");
        } else {
          showError(message);
        }

        break;
      }

      case 403:
        showError(message);
        break;

      case 404:
        showWarning(message);
        break;

      case 409:
        showWarning(message);
        break;

      case 422:
        showWarning(message);
        break;

      case 500:
        showError(message);
        break;

      default:
        showError(message);
        break;
    }

    return Promise.reject(error);
  }
);

export default apiClient;